import { AddressDto } from '@/lib/ServerApi';
import { z, ZodType } from 'zod';

export const addressValidationSchema = z.object({
    address: z.string().min(1, 'Address is required'),
    city: z.string().min(1, 'City is required'),
    state: z.string().min(1, 'State is required'),
    zipcode: z
        .string()
        .min(1, 'Zip code is required')
        .regex(/^\d{5,10}(?:[-\s]\d{4})?$/, { message: 'Zip code is invalid' })
        .refine(
            (val) => {
                if (!val) {
                    return true;
                }
                return val.length >= 5 && val.length <= 10;
            },
            { message: 'Zip code needs to be between 5 and 10 digits' },
        )
        .transform((val) => {
            if (!val) {
                return val;
            }
            return val;
        })
        .refine(
            (val) => {
                if (!val) {
                    return true;
                }
                return !isNaN(Number(val.replace(/[-\s]/, '')));
            },
            { message: 'Please enter a valid zip code' },
        ),
}) satisfies ZodType<AddressDto>;

export const addressOptionalValidationSchema = z.preprocess((raw) => {
    if (
        raw &&
        ['address', 'city', 'state', 'zipcode'].every((k) => {
            const v = (raw as any)[k];
            return v == null || (typeof v === 'string' && v.trim() === '');
        })
    ) {
        return undefined;
    }
    return raw;
}, addressValidationSchema.optional());

export type AddressSchema = z.infer<typeof addressValidationSchema>;
